import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CURRENCY_YEAR_ARCHIVE_SOURCE_FILTER_OPTIONS } from 'constants/currencyYearArchive';

import { Tab, TabsRow, Wrapper } from './styles';

const CurrencyYearArchiveSourceTabs = ({ activeSource, onSourceSelect }) => (
  <Wrapper>
    <TabsRow aria-label="currency year archive sources">
      {CURRENCY_YEAR_ARCHIVE_SOURCE_FILTER_OPTIONS.map(source => (
        <Tab
          key={source}
          type="button"
          $active={activeSource === source}
          aria-current={activeSource === source ? 'true' : undefined}
          onClick={() => onSourceSelect(source)}
        >
          <FormattedMessage
            id={`currencyYearArchivePage.sourceTab.${source}`}
          />
        </Tab>
      ))}
    </TabsRow>
  </Wrapper>
);

CurrencyYearArchiveSourceTabs.propTypes = {
  activeSource: PropTypes.string.isRequired,
  onSourceSelect: PropTypes.func.isRequired,
};

export default memo(CurrencyYearArchiveSourceTabs);
